module.exports = __webpack_public_path__ + "img/img6.8d060e4b.png";